"use client";

import { c as _c } from "react/compiler-runtime";
import { graphql, readFragment } from "@opensea/graphql";
import { useDropStore } from "@/components/collection/drops/components/CollectionDropContext";
import { DropStatus } from "@/components/collection/drops/constants";
import { HeroHeaderCompactLayout } from "@/components/hero-header/HeroHeaderCompactLayout";
import { CollectionMetadataChips } from "../CollectionMetadataChips";
import { CollectionMetadataChipsFragment } from "../CollectionMetadataChips/CollectionMetadataChips.fragment";
import { CollectionHeaderDropCountdown } from "./CollectionHeaderDropCountdown";
import { CollectionHeaderLayoutGroup, CollectionHeaderLayoutGroupFragment } from "./CollectionHeaderLayoutGroup";
import { CollectionInfo, CollectionInfoFragment } from "./CollectionInfo";
import { CollectionHeaderStats, CollectionHeaderStatsFragment } from "./CollectionStats";
export const CollectionHeaderCompactContentFragment = graphql(`
    fragment CollectionHeaderCompactContent on Collection {
      ...CollectionInfo
      ...CollectionHeaderStats
      ...CollectionMetadataChips
      ...CollectionHeaderLayoutGroup
    }
  `, [CollectionInfoFragment, CollectionHeaderStatsFragment, CollectionMetadataChipsFragment, CollectionHeaderLayoutGroupFragment]);
export function CollectionHeaderCompactContent(t0) {
  const $ = _c(15);
  const {
    collection: collectionKey
  } = t0;
  let t1;
  if ($[0] !== collectionKey) {
    t1 = readFragment(CollectionHeaderCompactContentFragment, collectionKey);
    $[0] = collectionKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const collection = t1;
  const status = useDropStore(_temp);
  let t2;
  if ($[2] !== collection || $[3] !== status) {
    t2 = status === DropStatus.MINTING_SOON ? <CollectionHeaderDropCountdown variant="compact" /> : <CollectionHeaderStats collection={collection} />;
    $[2] = collection;
    $[3] = status;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const statsModule = t2;
  let t3;
  let t4;
  if ($[5] !== collection) {
    t3 = <CollectionInfo collection={collection} />;
    t4 = <CollectionMetadataChips className="mt-4" collection={collection} variant="compact" />;
    $[5] = collection;
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  let t5;
  if ($[8] !== statsModule || $[9] !== t3 || $[10] !== t4) {
    t5 = <HeroHeaderCompactLayout info={t3} metadataChips={t4} stats={statsModule} />;
    $[8] = statsModule;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== collection || $[13] !== t5) {
    t6 = <CollectionHeaderLayoutGroup collection={collection}>{t5}</CollectionHeaderLayoutGroup>;
    $[12] = collection;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}
function _temp(state) {
  return state.status;
}